export default "__VITE_ASSET__5NWXyT$B__"